module.exports = __webpack_public_path__ + "img/trading4.8804697c.svg";